import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
    AuthModule,
    AUTH_SERVICE,
    PUBLIC_FALLBACK_PAGE_URI,
    PROTECTED_FALLBACK_PAGE_URI
} from 'ngx-auth';

import { AuthenticationService } from "app/brightserve/authentication.service";

import { AuthGuard } from "app/brightserve/auth-guard";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { BrightserveInterceptor } from "app/brightserve/brightserve-interceptor";
import { TokenStorageService } from "app/brightserve/token-storage.service";

import { AddressPipe } from "./pipes/address.pipe";
import { AVPUPipe } from "./pipes/avpu.pipe";
import { NewlinePipe } from './pipes/newline.pipe';
import { RoundPipe } from './pipes/round.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { ReversePipe } from './pipes/reverse.pipe';
import { TitleCaseSpacePipe } from './pipes/title-case-space.pipe';

export { Address } from "./address";
export { Coordinate } from "./coordinate";
export { GUID } from "./guid";
export { Param } from "./param";

export function factory(authenticationService: AuthenticationService) {
    return authenticationService;
}

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        AuthModule
    ],
    declarations: [RoundPipe, FilterPipe, AddressPipe, AVPUPipe, NewlinePipe, ReversePipe, TitleCaseSpacePipe],
    exports: [RoundPipe, FilterPipe, AddressPipe, AVPUPipe, NewlinePipe, ReversePipe, TitleCaseSpacePipe],
    providers: [
        AuthenticationService,
        TokenStorageService,
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BrightserveInterceptor,
            multi: true
        },
        { provide: PROTECTED_FALLBACK_PAGE_URI, useValue: '/' },
        { provide: PUBLIC_FALLBACK_PAGE_URI, useValue: '/login' },
        {
            provide: AUTH_SERVICE,
            deps: [AuthenticationService],
            useFactory: factory
        }
    ]
})
export class BrightServeModule { }



// WEBPACK FOOTER //
// ./src/app/brightserve/brightserve.module.ts